import type { BaseTabType, DataComponentType, MarketsComponentType } from '@/types/markets';

export const parseMarketComponent = (
  component: DataComponentType,
  version = '1'
): MarketsComponentType => {
  const id = crypto.randomUUID();
  const tabs = 'tabs' in component ? component.tabs : undefined;

  if (version === '1') {
    if (component.type === 'feed') {
      return {
        layout: component.layout,
        tabs: [{ name: 'Feed', ...component }] as BaseTabType[],
        id
      };
    }
    if (component.type === 'file_list') {
      return {
        layout: component.layout,
        tabs: [{ ...component, name: component.name ?? 'Data lake files' }] as BaseTabType[],
        id
      };
    }
    if (tabs) {
      return {
        layout: component.layout,
        tabs: tabs.map(item => ({ ...item, ...component })) as BaseTabType[],
        id
      };
    }
  }

  if (component.type === 'tiles') {
    return { layout: component.layout, component: component as unknown as BaseTabType, id };
  }

  if (Array.isArray(tabs)) {
    return { layout: component.layout, tabs: tabs as BaseTabType[], id };
  }

  const name = 'name' in component ? (component as { name?: string }).name : undefined;
  return {
    layout: component.layout,
    tabs: [{ ...component, name: name ?? '' }] as BaseTabType[],
    id
  };
};
